<template>
	<v-menu
		v-if="user"
		bottom
		min-width="300px"
		rounded
		max-width="400px"
		offset-y
		left
		:max-height="maxHeight"
		:close-on-content-click="false"
		class="ml-auto"
		v-model="show"
	>
		<template v-slot:activator="{ on }">
			<v-btn 
				v-on="on" 
				icon text 
				elevation="0" 
				plain 
				:class="{'mr-2': unreadMeta.total}"
				:loading="unreadLoading"

			>
				<v-icon>$notification</v-icon> 
				<v-badge
					v-if="unreadMeta.total"
					overlap 
					bordered 
					top 
					offset-y="3" 
					color="red"
					:content="unreadMeta.total >= 100 ? '99+' : unreadMeta.total"
				>
				</v-badge>
			</v-btn>
		</template>
		<v-card>
			<v-card-text class="pa-5">
				<div class="bold font-14 d-flex flex-row align-items-center">
					{{ $vuetify.lang.t('$vuetify.notifications.notifications') }}
					<v-btn @click="refresh()" :loading="unreadLoading" icon small class="ml-2"><v-icon>mdi-sync</v-icon></v-btn>
					<v-menu
						bottom
						min-width="250px"
						rounded
						offset-y
						left
						
					>
						<template v-slot:activator="{ on }">
							<v-btn
								v-on="on"
								text
								elevation="0"
								plain
								small
								color="grey"
								:ripple="false"
								class="mw-auto px-0 ml-auto"
							>
								<div class="icon"></div>
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</template>
						<v-list dense>
							<v-list-item @click="markAllAsRead()" dense class="font-12 link">
								{{ $vuetify.lang.t('$vuetify.notifications.markAll.read') }}
							</v-list-item>
							<v-list-item :to="{name: 'Settings', params: {typeOfSettings: 'notifications'}}"  @click.native="show = false" dense class="font-12 link">
								{{ $vuetify.lang.t('$vuetify.notifications.settings') }}
							</v-list-item>
							<v-list-item @click="goTo('Notifications')" :exact-active-class="null" :active-class="null" dense class="font-12 link">
								{{ $vuetify.lang.t('$vuetify.notifications.showAll') }}
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
				<v-list v-if="sortedUnreadNotifications.length" class="relative">
					<v-overlay
						v-if="savingAll"
						:value="true"
						absolute
						:dark="false"
						light
						color="white"
						opacity="0.8"
						>
						<v-progress-circular
							indeterminate
							size="50"
						></v-progress-circular>
					</v-overlay>
					<template v-for="notification in sortedUnreadNotifications">
						<notifications-item :notification="notification" :key="notification.id" @close="() => show = false" />
						<v-divider :key="`divider-${notification.id}`"/>
					</template>
				</v-list>
				<div v-else class="text-muted mt-3">
					{{ $vuetify.lang.t('$vuetify.notifications.noNewNotifications') }}
				</div>
				<div v-if="moreLoading" class="mt-5">
					<template v-for="n in 3">
						<v-skeleton-loader
							:key="n"
							type="list-item-avatar, card-action"
							class="py-3"
						></v-skeleton-loader>
						<v-divider :key="`divider-${n}`"/>
					</template>
				</div>
				<div v-if="unreadMeta.last_page != unreadMeta.current_page" class="text-center d-flex flex-wrap align-items-center">
					{{ unreadMeta.to }} {{ $vuetify.lang.t('$vuetify.paginate.of') }} {{ unreadMeta.total }}
					<v-btn @click="loadMore()" plain class="pa-0 ml-auto">{{ $vuetify.lang.t('$vuetify.notifications.loadMore') }}</v-btn>
				</div>
				<div class="mt-3">
					<v-btn
						block
						:to="{ name: 'Notifications' }"
						color="accent"
						elevation="0"
						height="32"
						@click="show = false"
					>
						{{ $vuetify.lang.t('$vuetify.notifications.showAll') }}
					</v-btn>
				</div>
			</v-card-text>
		</v-card>
		
	</v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import NotificationsItem from "@/components/notifications/NotificationsItem";
import _ from 'lodash';
export default {
	name: "UserMenu",
	components: {
		NotificationsItem
	},
	data() {
		return {
			show: false,
			moreLoading: false,
			savingAll: false
		}
		
	},
	computed: {
		...mapGetters({
			user: "auth/user",
			unreadNotifications: "notifications/unreadNotifications",
			unreadMeta: "notifications/unreadMeta",
			unreadLoading: "notifications/loadingUnreadNotifications"
		}),
		maxHeight() {
			if(document.body.clientHeight < 768) {
				return 'calc(100vh - 100px)';
			}
			return 768;
		},
		sortedUnreadNotifications() {
			return _.orderBy(this.unreadNotifications, 'created_at', 'desc');
		}
	},
	methods: {
		async refresh() {
			await this.$store.dispatch('notifications/getNotifications', {
				watched: 'no'
			});
		},
		async loadMore() {
			if(this.unreadMeta.current_page < this.unreadMeta.last_page) {
				this.moreLoading = true;
				await this.$store.dispatch('notifications/getNotifications', {
					page: this.unreadMeta.current_page + 1,
					watched: 'no'
				});
				this.moreLoading = false;
			}
		},
		goTo(routeName) {
			if(this.$route.name != routeName) {
				this.$router.push({name: routeName});
			}
			this.show = false;
		},
		async markAllAsRead() {
			this.savingAll = true;
			let res = await this.$store.dispatch('notifications/markAllWatched');
			if(res.success) {
				this.$snackbar.success("Pomyślnie oznaczono jako przeczytane!")
				await this.$store.dispatch('notifications/getNotifications', {watched: 'no'});
			}
			this.savingAll = false;
		},
		async markAllAsUnread() {
			let ids = this.unreadNotifications.map(x => x.id);
			let res = await this.$store.dispatch('notifications/updateStatus', {
				action: 'unwatched',
				notification_ids: ids
			});
			if(res.success) {
				this.$snackbar.success("Pomyślnie oznaczono!")
			}
			return ids;
		}
	}
};
</script>

<style lang="scss" scoped>
.user-name {
	font-weight: 500;
	text-align: left;
	.subtitle {
		color: $muted;
		font-size: 12px;
	}
}
</style>
